import React, { useContext, useEffect, useRef, useState } from "react";

import {
    View,
    Text,
    Platform,
    Image,
    TouchableOpacity,
    ScrollView
} from "react-native";
import User from "../../data/user/User";
import Images from "../../../specific/utils/Images";
import i18n from "../../utils/Localization/Localization";
import AppTheme from "../../utils/Theme";
import MenuStyle from "../../styles/menu/MenuStyle";
import { trackEvent } from "../../services/Tracking/Analytics";
import * as Navigation from "../../../specific/utils/Navigation/Navigation";
// Data
import { LocalDBContext } from "../../data/LocalDB";
import { ActivitiesMenuSettings } from "./Menu";
import Activity from "../../models/Activity";
import ActivitySquareButton from "../Activities/Component/ActivitySquareButton";
import ActivityLabelButton from "../Activities/Component/ActivityLabelButton";
import { useNavigate } from "../../../specific/utils/Navigation/Navigation";
import { EventFiltersByLevelChanged, ScreenActivitiesBySection, ScreenActivitySheet, UserType } from "../../utils/Constants";
import InViewModal from "../../../specific/components/InViewModal/InViewModal";
import { getLocalActivities } from "../../../specific/utils/LocalStorage";
import NavBar from "../NavBar/NavBar";
import NavBarTitle from "../NavBar/NavBarTitle";
import { getMenuConfiguration, LEVEL_CONF } from "./MenuConf";
import { EventRegister } from "../../utils/EventListeners";

interface ActivitiesMenuProps {
    componentId: string;
    settings: ActivitiesMenuSettings;
}

const ActivitiesMenu = (props: ActivitiesMenuProps) => {

    const { componentId, settings } = props;

    const [localActivities, setLocalActivities] = useState(undefined);
    const [refresh, setRefresh] = useState<number>(0);

    useEffect(() => {
        EventRegister.addEventListener(EventFiltersByLevelChanged, () => {
            setRefresh(new Date().getTime());
        });
        return () => {
            EventRegister.removeEventListener(EventFiltersByLevelChanged);
        };
    }, []);

    useEffect(() => {
        if (localActivities === undefined) {
            getActivities();
        }
    }, [localActivities]);

    let navigate = undefined;
    if (Platform.OS === "web") {
        navigate = useNavigate();
    }

    const user: User = User.getInstance();
    const images: Images = new Images();
    const appTheme: AppTheme = new AppTheme();
    const menuStyle: MenuStyle = new MenuStyle();

    const inViewModal = useRef<InViewModal>(null);

    const localDBData = useContext(LocalDBContext);

    const bodyTextSize = appTheme.pixelPerfectForFont(8);
    const sections = localDBData.sections.data;
    const flexDirection = appTheme.getFlexDirectionForSplitScreen();
    const levelConfiguration: LEVEL_CONF = getMenuConfiguration(user.children_level);

    const launchTheApp = (data: { section: any }) => {
        const { section } = data;
        const { key } = section;
        if ((key === "still") || (key === "talk") || (key === "grow") || (key === "liliAtSchool") || (key === "inspire")) {
            if (key === "still") {
                trackEvent("section_calm_clicked");
            } else if (key === "talk") {
                trackEvent("section_expression_clicked");
            } else if (key === "grow") {
                trackEvent("section_philo_clicked");
            } else if (key === "inspire") {
                trackEvent("section_inspire_clicked");
            }
            Navigation.push({
                componentId,
                navigate,
                name: ScreenActivitiesBySection,
                passProps: {
                    sectionKey: key
                }
            });
        }
    }

    const getActivities = async () => {
        const localActivitiesFromStorage = await getLocalActivities();
        setLocalActivities(localActivitiesFromStorage.data);
    }

    const launchActivity = (data: { activity: Activity }) => {
        const { activity } = data;
        let name = ScreenActivitySheet;
        let passProps = {
            activityKey: activity.key,
            categoryKey: activity.category_keys[0],
            sectionKey: activity.section_key,
            context: user.profile,
            isModal: true,
            showBg: false
        };
        //trackEvent(analyticsEventHpTrainingPathClicked);
        if (Platform.OS === "web") {
            inViewModal.current?.showAlert({
                name,
                passProps
            });
        } else {
            Navigation.showModal({
                componentId,
                navigate,
                passProps,
                name
            });
        }

    }

    const renderMainButtons = () => {

        let mainMenuButtons = [
            <View />,
            <View />,
            <View />,
            <View />
        ];

        // Liste des sections à afficher
        const sectionKeyArray: string[] = ["inspire", "still", "talk", "grow"];
        for (const aLocalSectionKey in sections) {
            if (Object.hasOwnProperty.call(sections, aLocalSectionKey)) {
                const aLocalSection = sections[aLocalSectionKey];
                const aLocalSectionTitle = ((aLocalSection.title !== undefined) && (aLocalSection.title.fr !== undefined)) ? aLocalSection.title.fr : "";
                let aLocalSectionBody = ((aLocalSection.appMenuBody !== undefined) && (aLocalSection.appMenuBody.fr !== undefined)) ? aLocalSection.appMenuBody.fr : "";
                if (user.profile !== undefined) {
                    if ((aLocalSection[user.profile] !== undefined) && (aLocalSection[user.profile].appMenuBody !== undefined) && (aLocalSection[user.profile].appMenuBody.fr !== undefined)) {
                        aLocalSectionBody = aLocalSection[user.profile].appMenuBody.fr;
                    }
                }
                if (sectionKeyArray.indexOf(aLocalSection.key) !== -1) {
                    const colors = aLocalSection.clr !== undefined ? aLocalSection.clr : { "action": "#ff855f", "main": "#ff855f", "txt": "#25364f" };
                    const textColor: string = colors.menu_txt !== undefined ? colors.menu_text : "#25364f";
                    let buttonPosition = 0;
                    let buttonImage = images[levelConfiguration[aLocalSection.key]];
                    if (aLocalSection.key === "still") {
                        buttonPosition = 1;
                    } else if (aLocalSection.key === "talk") {
                        buttonPosition = 2;
                    } else if (aLocalSection.key === "grow") {
                        buttonPosition = 3;
                    } else if (aLocalSection.key === "inspire") {
                        buttonPosition = 0;
                    } else if (aLocalSection.key === "actForThePlanet") {
                        buttonPosition = 4;
                    }
                    const imageSize: number = appTheme.getFlexDirectionForSplitScreen() === "row" ? appTheme.pixelPerfect(150) : appTheme.pixelPerfect(66);
                    const paddingTop: number = appTheme.getFlexDirectionForSplitScreen() === "row" ? appTheme.pixelPerfect(10) : 0;
                    const menuButton = <TouchableOpacity key={aLocalSection.key} onPress={() => launchTheApp({ section: aLocalSection })} style={[menuStyle.headingButtonStyle, { paddingTop, backgroundColor: colors.main, marginHorizontal: Platform.OS === "web" ? 10 : 0, borderRadius:appTheme.pixelPerfect(levelConfiguration.borderRadius) }]}>
                        <Image source={buttonImage} style={{ width: imageSize, height: imageSize }} resizeMode="contain" />
                        <View style={{ flex: 1, justifyContent: "flex-start", alignItems: "center", paddingVertical: 5 }}>
                            <Text style={[{ color: textColor, fontFamily: appTheme.superHerosFontBold, textAlign: "center", fontSize: bodyTextSize }]}>{aLocalSectionTitle.toLocaleUpperCase()}</Text>
                            <Text style={[{ fontFamily: appTheme.primarySemiBoldFont, color: textColor, textAlign: "center", fontSize: bodyTextSize, paddingTop: appTheme.pixelPerfect(5) }]}>{aLocalSectionBody}</Text>
                        </View>
                    </TouchableOpacity>;
                    mainMenuButtons[buttonPosition] = menuButton;
                }
            }
        }
        return mainMenuButtons;
    }

    const renderBackground = () => {
        if (levelConfiguration.background === false) {
            return <View />;
        }
        return <Image source={images.bgDayClouds} style={{ width: appTheme.getFullAppWidth(), height: appTheme.getFullScreenHeight(), position: "absolute" }} resizeMode="contain" />
    }

    const renderExtraContent = () => {
        if ((settings !== undefined) && (localActivities !== undefined)) {
            // On va récupérer les activités à afficher
            let onCoverActivitieKeys: string[] = settings.cover.all;
            if (settings.cover[user.profile] !== undefined) {
                onCoverActivitieKeys = settings.cover[user.profile];
            }
            let onCoverActivititesView: React.JSX.Element[] = [];
            for (const anActivityKeyIndex in onCoverActivitieKeys) {
                if (!Object.hasOwn(onCoverActivitieKeys, anActivityKeyIndex)) continue;
                const anActivityKey: string = onCoverActivitieKeys[anActivityKeyIndex];
                if (localActivities[anActivityKey] !== undefined) {
                    const activitiyToDisplay: Activity = localActivities[anActivityKey];
                    if ((Platform.OS === "web") && (appTheme.getFlexDirectionForSplitScreen() === "row")) {
                        onCoverActivititesView.push(<ActivityLabelButton key={`web_${anActivityKey}`} onPress={() => launchActivity({ activity: activitiyToDisplay })} activity={activitiyToDisplay} />)
                    } else {
                        onCoverActivititesView.push(<ActivitySquareButton key={`mobile_${anActivityKey}`} onPress={() => launchActivity({ activity: activitiyToDisplay })} activity={activitiyToDisplay} />);
                    }
                }
            }
            const userProfile: UserType = user.profile !== undefined ? user.profile : "teacher";
            return <View style={{ alignItems: "center", marginTop: Platform.OS === "web" ? appTheme.pixelPerfect(30) : appTheme.pixelPerfect(20), width: appTheme.getFullAppWidth() }}>
                <Text style={{ fontFamily: appTheme.primaryBoldFont, color:levelConfiguration.text_color, fontSize: Platform.OS === "web" ? appTheme.pixelPerfectForFont(8) : appTheme.pixelPerfectForFont(6) }}>{i18n.t(`menu.activities.extra.title.${userProfile}`).toLocaleUpperCase()}</Text>
                <View style={{ flexDirection: "row", justifyContent: "center", marginTop: Platform.OS === "web" ? appTheme.pixelPerfect(30) : appTheme.pixelPerfect(20), width: "100%" }}>
                    {onCoverActivititesView}
                </View>
            </View>
        }
        return <View />;
    }

    const userProfile: UserType = user.profile !== undefined ? user.profile : "family";
    return (
        <View style={{ flex: 1, width: appTheme.getFullAppWidth(), justifyContent: "center", alignItems: "center", paddingBottom: appTheme.bottomInsets + appTheme.pixelPerfect(60), paddingTop: appTheme.topInsets + 10, backgroundColor: levelConfiguration.background_color }}>
            {renderBackground()}
            <NavBarTitle titleColor={levelConfiguration.text_color} title={i18n.t("menu.activities." + userProfile)} />
            <View style={{ flex: 1, width: appTheme.getFullAppWidth(), alignItems: "center" }}>
                <ScrollView>
                    <View style={{ width: appTheme.getFullAppWidth(), flexDirection, alignItems: "center", justifyContent: "center" }}>
                        {renderMainButtons()}
                    </View>
                    {renderExtraContent()}
                </ScrollView>
            </View>
            <NavBar />
            <InViewModal ref={inViewModal} />
        </View>
    )
}

export default ActivitiesMenu;